import { Button, Form } from 'antd';
import { CreateMasterDTO } from 'features/master/api/master-api.service';
import { useCreateStation } from 'features/master/use-cases/create-station';
import { useGetStationtypeList } from 'features/master/use-cases/get-stationtype';
import { UserFormField, UserFormValues } from 'features/users/components/users-filter-form';
import { useEffect, useState } from 'react';

import { StaionsFormItems } from './station-form';


export const StationModalView = ({ onClose, userEditData }: { onClose: () => void, userEditData: any }) => {
    const formName = 'add-user-form';
    const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
    const [form] = Form.useForm<UserFormValues>();
    const { isLoading, mutate } = useCreateStation();
    const { data } = useGetStationtypeList('' as any)
    const handleSubmit = (formValues: CreateMasterDTO) => {
        const isEdit = !!userEditData?.id;

        const payload: any = {
            flag: isEdit ? "Upsert" : "Upsert",
            title: formValues?.title,
            description: formValues?.description,
            stationTypeId: userEditData?.type || formValues?.type,
        };

        if (isEdit) {
            payload.id = userEditData.id;
        }

        mutate(payload, { onSuccess: handleClose });
    };

    const handleClose = () => {
        onClose();
        form.resetFields();
    }
    useEffect(() => {
        if (userEditData) {
            userEditData.role = parseInt(userEditData.role);
            form.setFieldsValue(userEditData);
        } else {
            form.resetFields();
        }

    }, [userEditData, form]);

    const getInitialValues = {
        [UserFormField.FirstName]: undefined,
        [UserFormField.PhoneNumber]: undefined,
        [UserFormField.Role]: undefined,
        [UserFormField.Email]: undefined,

    };

    return (
        <>
            <div className={'popup'}>
                <div className='modal_head'>
                    <button onClick={handleClose} className='close-btn'>
                        &times;
                    </button>
                    <h4>{userEditData ? 'Edit Station' : 'Add Ststion'}</h4>
                </div>
                <div className='modal_body'>
                    <Form<UserFormValues>
                        id={formName}
                        name={formName}
                        form={form}
                        layout='vertical'
                        initialValues={getInitialValues}
                        onFinish={handleSubmit as any}
                        onFinishFailed={() => {
                            setValidateTrigger(['onChange']);
                        }}
                        validateTrigger={validateTrigger}
                        disabled={isLoading}
                    >
                        <StaionsFormItems data={data} />

                        <div className='form-button'>
                            <Button type="primary" htmlType='submit' className="btn" >Save</Button>
                        </div>
                    </Form>
                </div>
            </div>

        </>
    );
};

